@if(showHeader && headerContent){
<div class="d-lg-none d-block">
  <fgb-page-header [pageTitle]="headerContent.title" [backButtonLink]="'/games'" [showFooter]="false"> </fgb-page-header>
</div>
<div class="bg-primary" role="banner" [ngClass]="{ 'kid-bg': isKid }">
  <div class="container">
    <div class="d-none d-lg-flex text-white page-back-button-section pb-2 align-items-center" [routerLink]="['/games']">
      <span class="material-icons me-2">navigate_before</span>{{ 'games.back.button.text' | translate }}
    </div>
    <img class="trivia-banner" [src]="headerContent.bannerImg | contentAssetImage" alt="trivia-banner" />
  </div>
</div>
<div class="bg-muted">
  <div class="d-block bg-primary pb-4 pb-lg-0 pt-lg-3" [ngClass]="{ 'kid-bg': isKid }">
    <div class="container pb-2 pb-lg-0">
      <fgb-route-nav>
        <a
          class="nav-item leaderboard-nav-item"
          [ngClass]="{ 'nav-item-pickaplayer': isRulesEnabled }"
          [routerLink]="['/games/' + headerContent.routeLink]"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          attr.aria-label="{{ 'game.nav.' + headerContent.routeLink + '.v2.screenreader' | translate }}"
        >
          <label>{{ headerContent.routeLink + '.v2.nav.featured' | translate : { fgbdefault: 'Play' } }}</label>
        </a>
        <a
          class="nav-item leaderboard-nav-item"
          [ngClass]="{ 'nav-item-pickaplayer': isRulesEnabled }"
          [routerLink]="['/games/' + headerContent.routeLink + '/leaderboard-v2']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          attr.aria-label="{{ 'game.nav.' + headerContent.routeLink + '.v2.leaderboard.screenreader' | translate }}"
        >
          <label>{{
            'games.nav.' + headerContent.routeLink + '.v2.leaderboard' | translate : { fgbdefault: 'Leaderboard' }
          }}</label>
        </a>
        <a
          *ngIf="isRulesEnabled"
          class="nav-item leaderboard-nav-item"
          [ngClass]="{ 'nav-item-pickaplayer': isRulesEnabled }"
          [routerLink]="['/games/' + headerContent.routeLink + '/how-to-play']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          attr.aria-label="{{ 'game.nav.' + headerContent.routeLink + '.v2.rules.screenreader' | translate }}"
        >
          <label>{{
            'games.nav.' + headerContent.routeLink + '.v2.how.to.play' | translate : { fgbdefault: 'How to Play' }
          }}</label>
        </a>
      </fgb-route-nav>
    </div>
  </div>
  <div class="mobile-content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
}@else {
<router-outlet></router-outlet>

}
